import type { SortingFn } from "@tanstack/react-table";
import { toNumber } from "../../../lib/formatters";

// biome-ignore lint/suspicious/noExplicitAny: TanStack SortingFn is generic over row type; any matches the library's own signature
export const numericString: SortingFn<any> = (rowA, rowB, columnId) => {
	return toNumber(rowA.getValue(columnId)) - toNumber(rowB.getValue(columnId));
};
